<template>
  <div>
    <h3 class="text-center text-base text-gray-dark font-bold flex justify-center">
      {{ title }}

      <vs-tooltip class="flex ml-1 items-center" position="bottom">
        <template #content>
          <slot name="tooltipText"/>
        </template>

        <vs-icon icon="info" class="text-gray cursor-default"/>
      </vs-tooltip>
    </h3>

    <with-loader :id="id" class="flex justify-center flex-col text-center relative h-full"
                 :loading="isLoading"
                 use-as-overlay
    >
      <div class="text-6xl mt-5 py-6"
           :class="isLoading ? 'text-transparent' : 'text-primary-focus'"
      >
        <slot name="mainInfo"/>
      </div>

      <div
        class="absolute bottom-0 text-sm flex justify-center items-center w-full transform translate-y-8 text-gray-dark"
      >
        <slot name="extraInfo"/>
      </div>
    </with-loader>
  </div>
</template>

<script>
import WithLoader from '@/components/common/WithLoader'

export default {
  name: 'TextChart',

  components: {
    WithLoader
  },

  props: {
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
